module.exports = __webpack_public_path__ + "src/assets/textures/petri/loop_lambert1_AO.jpg";